import { render, staticRenderFns } from "./manage-group.vue?vue&type=template&id=89d2905c"
import script from "./manage-group.vue?vue&type=script&lang=js"
export * from "./manage-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports